import React from 'react';
import ServiceUnderConstruction from '../../components/ServiceUnderConstruction';
import logo from '../../assets/images/services/biofrit.webp';

const Biofrit = () => {
    return (
        <ServiceUnderConstruction
            serviceKey="biofrit"
            logo={logo}
            primaryColor="#FF6B35"
            secondaryColor="#FFA500"
        />
    );
};

export default Biofrit;
